<template>
  <div>
    <PageHeader :schema="$schemas.mdfe" />
    <PageContent>
      <DynamicListPage
        ref="DynamicListPage"
        :schema="$schemas.mdfe"
        :service="$api.mdfes"
        @actionMoreActions="actionMoreActions"
      />
    </PageContent>

    <DialogConfirmation
      :dialog="dialogConfirmationTransmit"
      :title="'Transmitir MDF-e'"
      :message="'Deseja Realmente Transmitir esta MDF-e?'"
      @noActionDialogConfirmation="closeConfirmationModal"
      @yesActionDialogConfirmation="transmit"
      :loading="loadingConfirmationTransmit"
    />
  </div>
</template>

<script>
import PageHeader from '@/components/PageHeader';
import PageContent from '@/components/PageContent';
import DynamicListPage from '@/components/dynamics/DynamicListPage';
import DialogConfirmation from '@/components/DialogConfirmation';
import Mdfe from '../model/Mdfe';

export default {
  name: 'ListMdfes',
  components: {
    PageHeader,
    PageContent,
    DynamicListPage,
    DialogConfirmation,
  },
  data() {
    return {
      mdfe: Mdfe.model,
      mdfeSelected: {},
      dialogConfirmationTransmit: false,
      loadingConfirmationTransmit: false,
    };
  },
  computed: {
  },
  mixins: [],
  methods: {
    actionMoreActions({ dataListPropsItem: { item }, moreActionItem }) {
      this.mdfeSelected = item;

      if (!moreActionItem.component) {
        this[moreActionItem.action]();

        return;
      }
      // this.openDialog(moreActionItem.component, moreActionItem.action);
    },
    openConfirmationModal() {
      this.dialogConfirmationTransmit = !this.dialogConfirmationTransmit;
    },
    closeConfirmationModal() {
      this.dialogConfirmationTransmit = false;
    },
    transmit() {
      this.loadingConfirmationTransmit = true;
      this.$api.mdfes.transmit({
        mdfe_id: this.mdfeSelected.id,
      }).then(({ data }) => {
        this.loadingConfirmationTransmit = false;

        if (data.status_code === '100' || data.status_code === '104') {
          this.$noty.success('MDF-e transmitida com sucesso');
        } else {
          this.$noty.error(data.reason);
        }
        this.closeConfirmationModal();
        this.$refs.DynamicListPage.fetchDataApi();
      }).catch((err) => {
        this.$noty.error('Erro ao transmitir a MDF-e');
      }).finally(() => {
        this.loadingConfirmationTransmit = false;
        this.closeConfirmationModal();
        this.$refs.DynamicListPage.fetchDataApi();
      });
    },
  },
};
</script>
